<template>
  <v-flex lg12>
    <!-- Module toggle grid -->
    <v-card class="module-grid-card">
      <div class="bulk-table-toolbar">
        <div class="bulk-table-toolbar__left">
          <h4 class="bulk-table-toolbar__title">Module Permissions</h4>
          <p class="bulk-table-toolbar__sub">Toggle modules for this school</p>
        </div>
        <div class="bulk-table-toolbar__actions">
          <v-btn flat color="secondary" class="table-toolbar-btn" @click="selectAllPermissions">
            <v-icon left small>done_all</v-icon>Select All
          </v-btn>
          <v-btn depressed color="primary" class="table-toolbar-btn table-toolbar-btn--primary" @click="permitToAssignModules">
            <v-icon left small>save</v-icon>Apply Changes
          </v-btn>
        </div>
      </div>
      <v-card-text class="module-grid-body">
        <div class="module-grid" v-if="complex.items.length">
          <button
            v-for="item in complex.items"
            :key="item._id || item.module"
            type="button"
            class="module-tile"
            :class="{ 'module-tile--enabled': item.enabled }"
            @click="toggleModule(item)"
          >
            <div class="module-tile__main">
              <div class="module-tile__icon">
                <v-icon small>extension</v-icon>
              </div>
              <div class="module-tile__copy">
                <div class="module-tile__name">{{ formatModuleName(item.module) }}</div>
                <div class="module-tile__slug">{{ item.module }}</div>
              </div>
            </div>
            <div class="module-tile__switch" @click.stop>
              <v-switch
                v-model="item.enabled"
                color="primary"
                class="module-switch"
              ></v-switch>
            </div>
          </button>
        </div>
        <div class="module-grid-empty" v-else>
          <v-icon class="module-grid-empty__icon">extension</v-icon>
          <div class="module-grid-empty__text">No modules available</div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Authorization dialog -->
    <v-dialog v-model="loginWindow" max-width="440px">
      <v-card class="auth-dialog">
        <div class="modal-header">
          <div class="modal-header__left">
            <div class="modal-header__icon-wrap modal-header__icon-wrap--warning">
              <v-icon class="modal-header__icon">lock</v-icon>
            </div>
            <div>
              <div class="modal-header__title">Confirm Authorization</div>
              <div class="modal-header__sub">Enter admin password to proceed</div>
            </div>
          </div>
          <v-btn icon flat class="modal-close-btn" @click="loginWindow = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider class="modal-divider"></v-divider>

        <div class="modal-body">
          <div class="form-field-label">Admin Password</div>
          <v-text-field
            v-model="password"
            type="password"
            outline
            placeholder="Enter your password"
            prepend-inner-icon="lock"
            class="auth-input"
            @keyup.enter.native="authAndProcceed"
          ></v-text-field>
        </div>

        <v-divider class="modal-divider"></v-divider>
        <div class="modal-footer">
          <v-btn flat class="modal-cancel-btn" @click="loginWindow = false">Cancel</v-btn>
          <v-btn depressed color="primary" class="modal-action-btn" @click="authAndProcceed">
            <v-icon left small>verified_user</v-icon>Authorize
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </v-flex>
</template>

<script>
import APIModule from "@/mixins/APIModule";
import mixinAuth from "@/mixins/APIAuth";
export default {
  props: ["company"],
  mixins: [APIModule, mixinAuth],
  data() {
    return {
      mod: {},
      password: "",
      loginWindow: false,
      addModule: false,
      search: "",
      complex: {
        selected: [],
        headers: [
          { text: "Module", value: "module", width: "100px", sortable: false },
          { text: "Enabled", align: "right", value: "", sortable: false }
        ],
        items: []
      }
    };
  },
  watch: {
    company: {
      handler: function() {
        this.analyzeExistance();
      },
      immediate: true
    }
  },
  mounted() {
    this.listAllModules();
  },
  methods: {
    analyzeExistance: function() {
      if (this.company && this.company.modules) {
        if (this.complex.items) {
          this.complex.items = this.complex.items.map(item => {
            let ob = item;
            this.$set(ob, "enabled", this.company.modules.includes(item.module));
            return ob;
          });
        }
      }
    },
    listAllModules: async function() {
      let modules = await this.getModules();
      this.complex.items = modules;
      this.analyzeExistance();
    },
    authAndProcceed: async function() {
      let login = { username: "superadmin", password: this.password };
      try {
        await this.authLogin(login);
        this.handleCompaniesAssignment();
      } catch (error) {
        this.$toast.error(
          "Failed to proceed with provided password. Try again",
          "Error",
          { position: "topCenter" }
        );
      }
    },
    selectAllPermissions: function() {
      for (const item of this.complex.items) {
        item.enabled = true;
      }
    },
    toggleModule: function(item) {
      this.$set(item, "enabled", !item.enabled);
    },
    formatModuleName: function(module) {
      return String(module || "")
        .replace(/_/g, " ")
        .toUpperCase();
    },
    permitToAssignModules: function() {
      this.loginWindow = true;
    },
    handleCompaniesAssignment: async function() {
      let company = this.company;
      let modules = this.complex.items
        .filter(obj => obj.enabled)
        .map(ob => ob.module);
      if (company) {
        var mod = { company: company._id, modules: modules };
        this.loginWindow = false;
        try {
          await this.assignModulesToCompany(mod);
          this.company.modules = modules;
          this.$toast.success(
            modules.length + " modules assigned successfully.",
            "Success",
            { position: "topCenter" }
          );
        } catch (error) {
          this.handleMultipleCompaniesAssignment();
        }
      }
    }
  }
};
</script>

<style scoped lang="css">
.module-grid-card { border-radius: 14px !important; overflow: hidden; }

.bulk-table-toolbar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; gap: 12px; flex-wrap: wrap;
}
.bulk-table-toolbar__left {}
.bulk-table-toolbar__title {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 15px;
  font-weight: 700; color: #1e293b; margin: 0;
}
.bulk-table-toolbar__sub {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 12px; color: #94a3b8; margin: 2px 0 0;
}
.bulk-table-toolbar__actions { display: flex; gap: 8px; }

.table-toolbar-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; border-radius: 10px !important; height: 38px !important;
}
.table-toolbar-btn--primary { box-shadow: 0 2px 8px rgba(21,101,192,0.3) !important; }

.module-grid-body {
  padding: 0 20px 20px !important;
}

.module-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
}

.module-tile {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  min-height: 76px;
  padding: 14px;
  text-align: left;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
  width: 100%;
}

.module-tile:hover {
  border-color: #bfdbfe;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.module-tile--enabled {
  background: #f8fbff;
  border-color: #93c5fd;
}

.module-tile__main {
  align-items: center;
  display: flex;
  gap: 12px;
  min-width: 0;
}

.module-tile__icon {
  align-items: center;
  background: rgba(21,101,192,0.1);
  border-radius: 8px;
  display: flex;
  flex-shrink: 0;
  height: 38px;
  justify-content: center;
  width: 38px;
}

.module-tile__icon >>> .v-icon {
  color: #1565C0 !important;
}

.module-tile__copy {
  min-width: 0;
}

.module-tile__name {
  color: #1e293b;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.35;
}

.module-tile__slug {
  color: #94a3b8;
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 12px;
  line-height: 1.35;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-tile__switch {
  flex-shrink: 0;
}

.module-switch {
  margin: 0 !important;
  padding-top: 0 !important;
}

.module-switch >>> .v-input__slot {
  margin-bottom: 0 !important;
}

.module-switch >>> .v-messages {
  display: none;
}

.module-grid-empty {
  align-items: center;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', 'Roboto', sans-serif;
  gap: 8px;
  justify-content: center;
  min-height: 160px;
}

.module-grid-empty__icon {
  color: #cbd5e1 !important;
  font-size: 42px !important;
}

.module-grid-empty__text {
  font-size: 14px;
}

/* Auth dialog */
.auth-dialog { border-radius: 16px !important; overflow: hidden; }

.modal-header {
  display: flex; align-items: center; justify-content: space-between; padding: 20px 20px 16px;
}
.modal-header__left { display: flex; align-items: center; gap: 14px; }
.modal-header__icon-wrap {
  width: 42px; height: 42px; border-radius: 12px;
  background: linear-gradient(135deg, #FB8C00, #e65100);
  display: flex; align-items: center; justify-content: center;
}
.modal-header__icon-wrap--warning {
  background: linear-gradient(135deg, #FB8C00, #e65100);
}
.modal-header__icon { color: #ffffff !important; font-size: 20px !important; }
.modal-header__title {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 16px; font-weight: 700; color: #1e293b;
}
.modal-header__sub { font-family: 'Inter', 'Roboto', sans-serif; font-size: 12px; color: #94a3b8; margin-top: 2px; }
.modal-close-btn { color: #94a3b8 !important; }
.modal-divider { border-color: #f1f5f9 !important; }

.modal-body { padding: 20px; }
.form-field-label {
  font-family: 'Inter', 'Roboto', sans-serif; font-size: 13px;
  font-weight: 600; color: #475569; margin-bottom: 6px;
}
.auth-input >>> .v-input__slot { background: #f8fafc !important; border-radius: 10px !important; }

.modal-footer {
  display: flex; align-items: center; justify-content: flex-end; gap: 8px; padding: 14px 20px;
}
.modal-cancel-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 500 !important;
  text-transform: none !important; color: #64748b !important; border-radius: 10px !important;
}
.modal-action-btn {
  font-family: 'Inter', 'Roboto', sans-serif !important; font-weight: 600 !important;
  text-transform: none !important; border-radius: 10px !important;
  height: 40px !important; padding: 0 20px !important;
  box-shadow: 0 2px 8px rgba(21,101,192,0.3) !important;
}

@media (max-width: 600px) {
  .bulk-table-toolbar,
  .bulk-table-toolbar__actions {
    align-items: stretch;
    flex-direction: column;
    width: 100%;
  }

  .module-grid-body {
    padding: 0 14px 14px !important;
  }

  .module-grid {
    grid-template-columns: 1fr;
  }
}
</style>
